//This file was created for fixing deps ring between rwc-logger and feature-flags
import { all, propIs } from 'ramda';
import { getPrefixedLogger, prefixes } from '@ringcentral/rwc-utils/src/rwc-logger';
import { calculatedFeatures } from '@ringcentral/rwc-utils/src/desktop-tools/feature-flags';
import { isApplication } from '@ringcentral/rwc-utils/src/client-detection';

const logger = getPrefixedLogger(prefixes.VC_UTILS, 'desktop-tools', 'feature-flags');

/**
 * @param   { boolean } apiExist req API is exist
 * @param   { String } featureName module name for warnings
 * @param   { String } apiName API/function name for warnings
 */
const showApiExistingWarning = (apiExist, featureName, apiName) => {
    if (!apiExist) {
        const logMessage =
            `${featureName} is enabled in config but was not injected, dependant experiences will be disabled.` +
            (apiName ? ` ${apiName} API is unavailable` : '');
        logger.warn(logMessage);
    }
};

/**
 * checks if some API dependencies of feature are missing. Warns if yes
 * @param   { FEATURE_KEY } featureKey
 * @returns { Boolean }
 */
const showFeatureAPIsWarnings = featureResult =>
    all(electronApiDepend =>
        showApiExistingWarning(
            featureResult.apiExist,
            featureResult.featureName,
            electronApiDepend.electronApiName
        )
    )(featureResult.electronApiDeps);

/**
 * Show information about feature flags to log
 * @param   { Object } featureResult contain flags
 * @param   { Boolean } validatedFlag already validated extended flag
 * @param   { Boolean } silent flag shows api logs
 */
const showLogFeatureCalculation = featureResult => {
    let logMessage;
    if (!propIs(Boolean, 'calculatedFeatureFlag', featureResult)) {
        logMessage = `IS_${featureResult.featureKey}_ENABLED = false(isNotNewElectron)`;
    } else {
        if (featureResult.showWarningIfApiNotProvided) {
            showFeatureAPIsWarnings(featureResult);
        }

        logMessage = `IS_${featureResult.featureKey}_ENABLED = ${
            featureResult.calculatedFeatureFlag
        } (config: ${featureResult.featureConfigExist}, api: ${
            featureResult.apiExist
        }, featureSet: ${!!featureResult.featureSetExist})`;
    }

    logger.info(logMessage);
};

if (isApplication()) {
    calculatedFeatures.forEach(showLogFeatureCalculation);
}
